<script setup lang="ts">
const bg = `${import.meta.env.YZ_IMAGE_PATH}/bg-grid.gif`;
</script>

<template>
  <div
    class="bg-grid"
    :style="{
      background: `url(${bg}) repeat scroll 0 0 white`
    }"
  >
    <slot></slot>
  </div>
</template>

<style scoped>
.bg-grid {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
</style>
